import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Person: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M10 8.90625C11.7259 8.90625 13.125 7.50714 13.125 5.78125C13.125 4.05536 11.7259 2.65625 10 2.65625C8.27411 2.65625 6.875 4.05536 6.875 5.78125C6.875 7.50714 8.27411 8.90625 10 8.90625ZM8.75 10C5.98858 10 3.75 12.2386 3.75 15V15.625C3.75 16.6605 4.58947 17.5 5.625 17.5H14.375C15.4105 17.5 16.25 16.6605 16.25 15.625V15C16.25 12.2386 14.0114 10 11.25 10H8.75Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Person;